<template>
  <div class="p-10" style="max-width: 610px; padding: 10px 20px;">
    <Table
      :columns="columns"
      :data="records"
      size="small"
      stripe
      :loading="loading"
    >
      <template slot-scope="{ row }" slot="action">
        <template v-if="!isClaimed">
          <a
            href="#"
            class="text-primary mr-2"
            v-tooltip="$t('edit')"
            @click.prevent="startEdit(row)"
          >
            <i class="fas fa-edit"></i>
          </a>
          <a-popconfirm
            placement="leftTop"
            :title="$t('are_you_sure_to_delete')"
            :ok-text="$t('yes')"
            :cancel-text="$t('no')"
            @confirm="deleteRow(row)"
          >
            <a href="#">
              <i class="fa fa-trash text-red"></i>
            </a>
          </a-popconfirm>
        </template>
        <span v-else class="text-muted">
          <i class="fas fa-lock"></i>
        </span>
      </template>
    </Table>

    <!-- Inline edit modal -->
    <a-modal
      v-if="showEditForm"
      v-model="showEditForm"
      :title="$t('employeeMission.advanceRequest')"
      centered
      :zIndex="1030"
      :footer="null"
      :width="400"
      @cancel="cancelEdit"
    >
      <div class="ts-space-y-3">
        <div>
          <label class="ts-text-xs required">{{
            $t('employeeMission.advanceAmount')
          }}</label>
          <input
            v-model.number="editRow.advance_amount"
            type="number"
            class="form-control"
          />
        </div>
        <div>
          <label class="ts-text-xs">{{ $t('employeeMission.remark') }}</label>
          <input v-model="editRow.remark" type="text" class="form-control" />
        </div>
        <div class="text-right ts-space-x-2">
          <ts-button @click.prevent="cancelEdit">{{ $t('cancel') }}</ts-button>
          <ts-button
            color="primary"
            :waiting="waiting"
            :disabled="waiting"
            @click.prevent="saveEdit"
          >
            {{ $t('update') }}
          </ts-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import missionAdvanceRequest from '@/api/mission/mission-advance-request'

export default {
  name: 'TableExpand',
  props: {
    row: { type: Object, required: true }
  },
  data() {
    return {
      loading: false,
      waiting: false,
      records: [],
      showEditForm: false,
      editRow: { id: null, advance_amount: 0, remark: '' }
    }
  },
  computed: {
    isClaimed() {
      return !!this.row.is_claimed
    },
    columns() {
      return [
        {
          title: '#',
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: this.$t('employeeMission.advanceAmount'),
          key: 'advance_amount',
          align: 'right',
          width: 150
        },
        {
          title: this.$t('employeeMission.remark'),
          key: 'remark',
          maxWidth: 300
        },
        {
          title: this.$t('actions'),
          slot: 'action',
          align: 'right'
        }
      ]
    }
  },
  async mounted() {
    await this.loadRecords()
  },
  methods: {
    async loadRecords() {
      this.loading = true
      try {
        this.records = await missionAdvanceRequest.get(this.row.id)
      } catch (e) {
        this.$toasted.error(e.message)
      } finally {
        this.loading = false
      }
    },
    startEdit(record) {
      this.editRow = {
        id: record.id,
        advance_amount: record.advance_amount,
        remark: record.remark
      }
      this.showEditForm = true
    },
    cancelEdit() {
      this.showEditForm = false
      this.editRow = { id: null, advance_amount: 0, remark: '' }
    },
    async saveEdit() {
      this.waiting = true
      try {
        await missionAdvanceRequest.update(this.editRow.id, {
          advance_amount: this.editRow.advance_amount,
          remark: this.editRow.remark
        })
        this.$toasted.success('Updated successfully')
        this.showEditForm = false
        await this.loadRecords()
        this.$emit('updated')
      } catch (e) {
        this.$toasted.error(e.message)
      } finally {
        this.waiting = false
      }
    },
    async deleteRow(record) {
      try {
        await missionAdvanceRequest.destroy(record.id)
        this.$toasted.success('Deleted successfully')
        await this.loadRecords()
        this.$emit('updated')
      } catch (e) {
        this.$toasted.error(e.message)
      }
    }
  }
}
</script>
